import { createContext } from 'react';

import { DatadogContextType } from './DatadogContextProvider';

export const DatadogContext = createContext<DatadogContextType | undefined>(
  undefined
);
